import React from 'react'
import InitialAvatar from '../InitialAvatar/InitialAvatar'
import s from './styles/StudentCard.module.scss'

const statusMap = {
	needsHelp: '🚩 Needs Help',
	onTrack: '✅ On Track',
	parentMisalign: '⚖️ Parent Misalign',
	starred: '⭐ Starred',
	recentlyActive: '⏳ Recently Active',
}

const StudentCard = ({ student, onClick }) => {
	return (
		<article className={s.card} onClick={onClick}>
			<header className={s.header}>
				<div className={s.user}>
					<InitialAvatar
						name={student.name}
						size={48}
						avatarKey={student.avatarKey}
						avatarSource={student.avatarSource}
						photoUrl={student.photoUrl}
					/>
					<div>
						<p className={s.name}>{student.name}</p>
						<p className={s.meta}>
							{student.grade} • {student.lastActive}
						</p>
					</div>
				</div>

				<span className={s.status}>
					{statusMap[student.status] || student.status}
				</span>
			</header>

			<ul className={s.details}>
				<li className={s.detailsItem}>
					<span className={`material-icons-outlined ${s.icon}`}>work</span>
					<span className={s.label}>Career:</span> {student.career}
				</li>
				<li className={s.detailsItem}>
					<span className={`material-icons-outlined ${s.icon}`}>public</span>
					<span className={s.label}>Country:</span>{' '}
					{student.country || '—'}
				</li>
				<li className={s.detailsItem}>
					<span className={`material-icons-outlined ${s.icon}`}>school</span>
					<span className={s.label}>Course:</span> {student.course}
				</li>
			</ul>

			<div className={s.progressBlock}>
				<p className={s.progressText}>
					Readiness:{' '}
					<span className={s.progressValue}>{student.readiness}%</span>
				</p>
				<div className={s.progressBar}>
					<div
						className={s.progressFill}
						style={{ width: `${student.readiness}%` }}
					/>
				</div>
			</div>

			<button className={s.button}>Message</button>
		</article>
	)
}

export default StudentCard
